// 中文简体文件


module.exports = {
    // 主页
    home: {
        bannerFloting: '弹指间便能全方位比较 平台，助你选择最抵丶 最快捷的物流路线。',
        nowSing: '立即免费注册',
        tab:['快速报价', '追踪货物', '本地仓储'],
        queryShipment: {
            company: '速遞公司',
            number: '追跡號碼 ',
            tips: '* 最多輸入25組在追跡號碼，一列一個',
            placeholder: '请输入快递单号'
        },
        help: '有问题需要帮忙吗？',
        localStorage: {
            reserve: {
                title: '预约',
                description: '简单线上或电话我们免费派送存储箱到府上',
            },
            tidy: {
                title: '收拾',
                description: '将你的个人物品放到存储箱并设定个人安全密码锁好'
            },
            store: {
                title: '存储',
                description: '当你准备就绪，请联络我们并安排上门收去你的存储箱，并妥善仓储'
            },
            extract: {
                title: '提取',
                description: '一有需要,只要透过网上的户口 管理安排取回你所需的储存箱, 我们便会把储存箱送回府上'
            }
        },
        whyChoice: {
            title: '為何選擇Goods 2 Go',
            oneBlock: {
                title: '跨境電商貨運配送',
                text: '我們知道優質的電子商貿物流服務對你的B2C業務(商家對顧客)至為重要。 「好運」致力為你提供最實惠和方便快捷的跨境物流方案，包括香港進口、出口、空運、 電商倉儲配送服務。'
            },
            twoBlock: {
                title: '標準快遞服務',
                text: '需要門對門標準快遞服務？只要登入「好運」系統，質優價廉的快遞服務便在你手中。你只需按步驟下單和列印運送標籤，而相關文件、上門收件和派送服務系統都為你安排妥當，在三個工作天內整個快遞服務便能輕鬆完成。'
            },
            threeBlock: {
                title: '全方位比較平台',
                text: '如何尋找最便宜而又切合你需要的快遞服務，同時又不用多花時間？「好運」的搜尋比較功能給你兩全其美的方案。你只需輸入基本資料如寄件地及收件區的地址、聯絡人、貨品的類別尺寸和重量，各大快遞公司的運費報價馬上一目了然，選擇心水快遞服務就是這麼簡單。省時省力省錢就從你選用「好運」開始！'
            },
            fourBlock: {
                title: '倉儲服務',
                text: '我們深明優質的物流服務也要良好的倉儲服務配合。「好運」樂意為你提供專業的倉儲、訂單流程管理、貨物存取、包裝、物流配送等一站式服務，讓你的管理得心應手。'
            }
        }
    },
    // 头部
    header: {
        mail :"立即寄件",
        hello: '你好',
        login: '登入',
        logout: "登出",
        cancel: "是否确认登出帐户?"
    },
    // 起点终点选择
    shipmentStarEnd: {
        start: "发货地",
        end: '目的地',
        startPlacehodler: '发货地',
        endPlacehodler: '请先选择发货地'
    }
}